var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u-curricular-carrera-a-b-m',{attrs:{"headers":_vm.headers,"carrera_id":this.carrera_id},scopedSlots:_vm._u([{key:"item.cuatrimestre",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.nombreCuatrimestre)+" ")]}},{key:"item.campo.codigo",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.campo.codigo)+" ")]}},{key:"item.docentes",fn:function(ref){
var item = ref.item;
return _vm._l((item.docentes),function(docente){return _c('div',{key:docente.id},[_vm._v(" "+_vm._s(docente.apellido)+" ")])})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }